import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { Holygrail } from 'components/organisms/customer-portal/widgets/space/components';
import { useIsTablet } from 'hooks/use-media-query';
import { CpLoadingDesc, CpLoadingProps, CpLoadingTitle } from '../common';

const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 300px !important;
  padding: var(--cp-spacing-06);
  border-right: 1px solid var(--cp-border-subtle);

  @media (max-width: 768px) {
    width: 100% !important;
    border-right: none;
  }
`;

const SidebarSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  .ant-skeleton-button,
  &.ant-skeleton,
  &.ant-skeleton-button,
  & {
    height: 48px;
    width: 100% !important;
  }

  margin-bottom: var(--cp-spacing-05);
`;

const ContentWrapper = styled.div`
  height: 100%;
  width: calc(100% - 300px);
  padding: var(--cp-spacing-06);
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ContentTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--cp-spacing-06);
  width: 100%;

  @media (max-width: 480px) {
    padding-bottom: 0;
    padding-top: 0;
  }
`;

const ContentTitleSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    height: 32px;
    width: 50% !important;
  }

  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
  }
`;

const ThumbnailsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(174px, 1fr));
  gap: var(--cp-spacing-06);
  margin-top: var(--cp-spacing-06);
`;

const ThumbnailSkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    height: 174px;
    width: 174px !important;
  }
  .ant-skeleton-button,
  &.ant-skeleton-button {
    width: 100% !important;
  }
`;

export const CpSpacesAndFilesLoadingSkeleton: React.FC<CpLoadingProps> = ({
  styles,
}) => {
  const isResponsive = useIsTablet();

  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      <Holygrail>
        <SidebarWrapper>
          <SidebarSkeleton active />
          <SidebarSkeleton active />
          <SidebarSkeleton active />
        </SidebarWrapper>
        {isResponsive ? (
          <></>
        ) : (
          <ContentWrapper>
            <ContentTitleWrapper>
              <ContentTitleSkeleton active />
            </ContentTitleWrapper>
            <ThumbnailsWrapper>
              <ThumbnailSkeleton active />
              <ThumbnailSkeleton active />
              <ThumbnailSkeleton active />
              <ThumbnailSkeleton active />
            </ThumbnailsWrapper>
          </ContentWrapper>
        )}
      </Holygrail>
    </CpSectionWrapper>
  );
};
